import Modal from '../alerts/modal.js';

import Api from '../api/api.js';


export default class ChangeLanguage {


	init()
	{
		this.cacheDom();

		this.bindEvents();
	}


	cacheDom()
	{
		this.$change_lang = $('.change-language');
	}


	bindEvents()
	{
		this.$change_lang.on('click', this.onChangeLanguage.bind(this));
	}


	onChangeLanguage(e)
	{
		e.preventDefault();
		
		const id = $(e.currentTarget).data('lang');
		
		this.changeLanguage(id).then((response) => {

			this.languageChanged();
		
		});
	}


	changeLanguage(id)
	{
		return new Promise((resolve, reject) => {
      	
        	(new Api).putRequest(`/language`, {id}).then((response) => {

          		resolve(response);
        	
        	})
        	
      	});
    }


	languageChanged()
	{
		(new Modal).success('Language Updated', 'Your language settings were successfully updated', 'Ok').then(() => {
			
			window.location.reload();
		
		});
	}


}